import { Bell, CheckCheck } from 'lucide-react'
import { useNotifications, useMarkNotificationRead } from '@/hooks/use-notifications'
import { NOTIFICATION_LABELS } from '@/lib/constants'
import { formatRelative } from '@/lib/format'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { ScrollArea } from '@/components/ui/scroll-area'
import { EmptyState } from '@/components/common/states'

export function NotificationsMenu() {
  const { data: notifications = [] } = useNotifications()
  const markRead = useMarkNotificationRead()
  const unread = notifications.filter((n) => !n.is_read).length

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Notificações" className="relative">
          <Bell className="h-5 w-5" />
          {unread > 0 && (
            <span className="absolute right-1.5 top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-destructive px-1 text-[10px] font-bold text-destructive-foreground">
              {unread > 9 ? '9+' : unread}
            </span>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0">
        <div className="flex items-center justify-between border-b p-3">
          <p className="text-sm font-semibold">Notificações</p>
          {unread > 0 && (
            <Button
              variant="ghost"
              size="sm"
              className="h-7 text-xs"
              onClick={() => markRead.mutate('all')}
            >
              <CheckCheck className="h-3.5 w-3.5" /> Marcar todas
            </Button>
          )}
        </div>
        <ScrollArea className="max-h-96">
          {notifications.length === 0 ? (
            <div className="p-4">
              <EmptyState icon={Bell} title="Sem notificações" className="border-0 p-4" />
            </div>
          ) : (
            <ul className="divide-y divide-border/60">
              {notifications.map((n) => (
                <li key={n.id}>
                  <button
                    onClick={() => !n.is_read && markRead.mutate(n.id)}
                    className={cn(
                      'flex w-full flex-col gap-0.5 p-3 text-left transition-colors hover:bg-accent/50',
                      !n.is_read && 'bg-primary/5',
                    )}
                  >
                    <div className="flex items-center justify-between gap-2">
                      <span className="text-xs font-medium text-primary">
                        {NOTIFICATION_LABELS[n.type]}
                      </span>
                      <span className="text-[11px] text-muted-foreground">
                        {formatRelative(n.created_at)}
                      </span>
                    </div>
                    <p className="text-sm font-medium">{n.title}</p>
                    {n.body && (
                      <p className="line-clamp-2 text-xs text-muted-foreground">{n.body}</p>
                    )}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </ScrollArea>
      </PopoverContent>
    </Popover>
  )
}
